import * as React from 'react';
import { useState } from "react";
import MainStaticPageForm from "../../components/MainStaticPages/MainStaticPageForm/MainStaticPageForm";
import Submenu from "../../components/Submenu/Submenu";
import AppMenus from "../../config/appMenus";
import AppRoutes from "../../config/appRoutes";
var MainStaticPage = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var submenu = null;
    if (isEdit) {
        submenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editStaticPage.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432a \u0441\u0442\u0430\u0442\u0438\u0447\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? submenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(MainStaticPageForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default MainStaticPage;



//////////////////
// WEBPACK FOOTER
// ./src/views/MainStaticPages/MainStaticPage.tsx
// module id = 364
// module chunks = 0